/** @jsx jsx */
import { useState } from 'react'
import { css, jsx, keyframes } from '@emotion/core'

import noAnswersIcon from '../../assets/icons/no-asnwers.svg'
import RaportManager from '../RaportManager'
import Pending from './Pending'
import Response from './Response'

const showReport = keyframes`
  to {
    opacity: 1;
  }
`

const reportCss = css`
  overflow-y: scroll;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;

  .export {
    margin-bottom: 40px;

    @media (max-width: 640px) {
      margin-bottom: 30px;
    }
  }

  .content {
    width: calc(100% - 100px);
    min-height: 200px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 50px;
    padding: 0 50px;
    justify-items: center;
    opacity: 0;
    animation: ${showReport} 0.2s ease forwards 0.3s;

    @media (max-width: 1255px) {
      grid-template-columns: 1fr;
    }

    @media (max-width: 560px) {
      padding: 0;
      width: 100%;
    }
  }

  .field {
    margin-bottom: 30px;
    margin-top: 0px;
  }

  .visitor-response {
    display: flex;
    flex-direction: column;
    background-color: white;

    width: calc(100% - 40px);
    max-width: 500px;
    padding: 20px;
    border-radius: 10px;
    box-shadow: rgb(228 228 228) 0px 1px 5px 0px;

    :nth-of-type(2n) {
      margin-right: auto;
    }

    :nth-of-type(2n + 1) {
      margin-left: auto;
    }

    @media (max-width: 1320px) {
      margin: 0 !important;
    }
  }

  .visitor-response-empty {
    display: flex;
    flex-direction: column;

    width: calc(100% - 40px);
    max-width: 500px;
    padding: 20px;
    border-radius: 10px;

    :nth-of-type(2n) {
      margin-right: auto;
    }

    :nth-of-type(2n + 1) {
      margin-left: auto;
    }

    @media (max-width: 1320px) {
      margin: 0 !important;
    }
  }

  .question {
    font-weight: 300;
    margin-bottom: 5px;
    font-size: 14px;
  }

  .answer {
    font-size: 14px;
    overflow: hidden;
  }

  .lc-badge {
    background-color: rgb(63, 140, 255);
    margin-bottom: 10px;
    width: 18px;
  }

  .divider {
    display: inline-block;
    width: calc(100% - 18px);
    height: 2px;
    background-color: #85a3f3;
    margin-bottom: 3px;
  }

  .empty-box {
    height: 270px;
  }

  .no-answers {
    display: flex;
    align-items: center;
    color: hsl(0, 0%, 70%);
    font-weight: 100;
    margin-top: 120px;

    > img {
      margin-right: 7px;
    }
  }
`

const DetailedReport = ({
  surveyName,
  structure,
  response,
  isLoading: isResponseLoading,
  updateFeeback,
  setSelectDisabled,
  surveyId,
  setSurveysLoading,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)

  const [isTooltipOpen, setIsTooltipOpen] = useState(false)
  const isResponse = response && response.length > 0

  const isPending = isResponseLoading || isLoading

  const refresh = () => {
    setIsLoading(true)
    setIsDisabled(true)
    setSelectDisabled(true)
    setIsTooltipOpen(false)
    setSurveysLoading(true)
    setTimeout(() => {
      updateFeeback().then(() => {
        setIsLoading(false)
        setIsDisabled(false)
        setSelectDisabled(false)
        setIsTooltipOpen(false)
        setSurveysLoading(false)
      })
    }, 3000)
  }

  return response ? (
    <div css={reportCss}>
      <RaportManager
        response={response}
        refresh={refresh}
        setIsTooltipOpen={setIsTooltipOpen}
        isTooltipOpen={isTooltipOpen}
        surveyName={surveyName}
        structure={structure}
        surveysLoading={isDisabled || isResponseLoading}
      />
      <div className="content">
        {isPending ? (
          <Pending surveyId={surveyId} structure={structure} />
        ) : (
          isResponse && <Response surveyId={surveyId} structure={structure} />
        )}
      </div>
    </div>
  ) : (
    <span className="no-asnwers">
      <img src={noAnswersIcon} alt="no answers" /> <span>No answers given</span>
    </span>
  )
}

export default DetailedReport
